const ActivityModalType=[
    {activityType: "memoryGame", 
        withFriend: "memoryGameModalSizeFriend", noFriend: "memoryGameModalSize"},
    {activityType: "pictureReveal", 
        withFriend: "underCoverModalSize", noFriend: "underCoverModalSize", modalClass: "underCoverModalClass"},
    {activityType: "jigsawPuzzle", 
        withFriend: "jigsawPuzzleModalSize", noFriend: "jigsawPuzzleModalSize", 
        modalClass: "jigsawPuzzleModalClass"},
    {activityType: "dragNdrop",
        withFriend: "dragNDropModalSize", noFriend: "dragNDropModalSize", modalClass: "dragNDropModalClass"},
    {activityType: "maze",
        withFriend: "mazeModalSize", noFriend: "mazeModalSizeNoFriend", modalClass: "mazeModalClass"},
     {activityType: "wordPuzzle",
        withFriend: "wordPuzzleModalSize", noFriend: "wordPuzzleModalSizeNoFriend", 
        modalClass: "wordPuzzleModalClass"},
    {activityType: "comedyClub",
        withFriend: "comedyClubModalSize", noFriend: "comedyClubModalSizeNoFriend",
         modalClass: "comedyClubModalClass"},
    
    
]
export default ActivityModalType;